












import { Component, Vue, Prop } from 'vue-property-decorator';
import kdButton from '../kdButton/index.vue';

@Component({
  components: {
    kdButton
  }
})
export default class ToolBar extends Vue {
  /** 是否固定定位 */
  @Prop({ default: true }) fixed!: boolean;

  /** ToolBar 层级 */
  @Prop({ default: 1 }) zIndex!: number | string; // 层级

  /** 是否需要占位 */
  @Prop({ default: true }) placeholder!: boolean;

  /** 是否可以点击样式 */
  @Prop({ default: false }) public disabled!: boolean;

  /** 是否可以点击中 */
  @Prop({ default: false }) public isCanClick!: boolean;

  /** 按钮文案 */
  @Prop({ default: '' }) btnWord!: string;

  /** 是否固定定位 */
  @Prop({ default: true }) safeAarea!: boolean;

  handleBtnClick() {
    this.$emit('handleBtnClick');
  }

  private timer:any;

  get toolBarStyle() {
    return {
      zIndex: this.zIndex
    };
  }

  mounted() {
     this.timer = setTimeout(() => {
      const kdPlaceholder = this.$refs.kdPlaceholder as HTMLElement;
      const kdToolBar = this.$refs.kdToolBar as HTMLElement;
      if (kdPlaceholder) {
        kdPlaceholder.style.height = kdToolBar.clientHeight + 'px';
      }
    }, 200);
  }

  destroyed() {
    clearTimeout(this.timer);
  }
}
